// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Cv6R","footer":"ModalCreateQualiphyProcedure_footer__2kiGq","additionData":"ModalCreateQualiphyProcedure_additionData__Xmfkr"};